<div class="color-highlight" [ngClass]="{
    'done' : type === 'finish',
    'fail' : type === 'fail',
    'conditionally' : type === 'success'
   }">
  <div class="color-highlight-round"></div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
